import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { PublicRoutes } from '../../public.routes';
import { CommonService } from '../../../_core/services/common.service';
import { AppRoutes } from '../../../app.routes';
import { Images } from '../../../../assets/data/images';
import { AdminRoutes } from '../../../admin/admin.routes';
import { AuthRoutes } from '../../../auth/auth.routes';

@Component({
  selector: 'public-header',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class PublicHeaderComponent {
  public mainLogo: string = Images.mainLogo;
  readonly publicRoutes = PublicRoutes;
  readonly authRoutes = AuthRoutes;
  readonly appRoutes = AppRoutes;
  readonly adminRoutes = AdminRoutes;
  constructor(public readonly commonService: CommonService) {}
}
